// extracted by mini-css-extract-plugin
export default {"button":"CustomColumnMenu_button__jgJLL","popup-content":"CustomColumnMenu_popup-content__N6GzO"};